import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { makeGraphQLRequest } from "..";

const getAgentFunction = async (id) => {
  return makeGraphQLRequest(
    graphqlOperation(queries.getAgentFunction, { id })
  );
};

const getAgentFunctionsByWorkspaceID = ({ workspaceID }) =>
  makeGraphQLRequest(
    graphqlOperation(queries.functionsByWorkspace, { workspaceID })
  );
const getAgentHostingsByWorkspaceID = ({ workspaceID }) =>
  makeGraphQLRequest(
    graphqlOperation(queries.hostingsByWorkspace, { workspaceID })
  );
const createAgentFunction = (object, userId = null) => {
  const input = { ...object };
  if (userId) {
    input.createdBy = userId;
    input.updatedBy = userId;
  }
  return makeGraphQLRequest(
    graphqlOperation(mutations.createAgentFunction, { input })
  );
};

const updateAgentFunction = (object, _version, userId = null) => {
  const input = { ...object, _version };
  if (userId) {
    input.updatedBy = userId;
  }
  return makeGraphQLRequest(
    graphqlOperation(mutations.updateAgentFunction, { input })
  );
};

const deleteAgentFunction = async (id) => {
  // First, fetch the current version of the agent
  const getAgentFunctionResult = await makeGraphQLRequest(
    graphqlOperation(queries.getAgentFunction, { id })
  );
  const currentAgent = getAgentFunctionResult.data.getAgentFunction;

  return makeGraphQLRequest(
    graphqlOperation(mutations.deleteAgentFunction, {
      input: {
        id,
        _version: currentAgent._version,
      },
    })
  );
};

export default {
  getAgentFunction,
  getAgentFunctionsByWorkspaceID,
  createAgentFunction,
  updateAgentFunction,
  deleteAgentFunction,
  getAgentHostingsByWorkspaceID,
};
